import { useToast } from '../context/ToastContext';
import { LECTURERS, PT } from '../data/mockData';

export default function LecturersPage() {
  const { show } = useToast();

  return (
    <div>
      <div className="sh-ey">RESOURCES · LECTURERS &amp; INDUSTRY TRAINERS</div>
      <div className="sh-ti">Lecturers &amp; Guide Trainers</div>
      <div className="sh-de">All TMIS faculty including STB-licensed tourist guide trainers, AI specialists, and social media strategists. STB licence expiry dates are monitored automatically.</div>
      <div style={{ display: 'flex', gap: '.75rem', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '.48rem', background: 'var(--surface)', border: '1.5px solid var(--border)', borderRadius: 'var(--rs)', padding: '.42rem .9rem', flex: 1, maxWidth: 300 }}>
          <i className="fa-solid fa-magnifying-glass" style={{ color: 'var(--slate-lt)', fontSize: '.88rem' }} />
          <input type="text" placeholder="Search lecturers…" style={{ background: 'none', color: 'var(--ink)', fontSize: 'var(--text-sm)', flex: 1 }} />
        </div>
        <select className="finput" style={{ width: 195 }}>
          <option>All Specialisms</option>
          <option>Tourist Guiding (STB)</option>
          <option>Hospitality</option>
          <option>AI in Tourism</option>
          <option>Social Media</option>
        </select>
        <button className="btn btn-ai btn-sm" onClick={() => show('AI load check — coming soon', 'info')}><i className="fa-solid fa-robot" /> AI Load Check</button>
        <button className="btn btn-primary" style={{ marginLeft: 'auto' }} onClick={() => show('Add lecturer — coming soon', 'info')}><i className="fa-solid fa-plus" /> Add Lecturer</button>
      </div>
      <div className="g4" style={{ marginBottom: '1.5rem' }}>
        <div className="sc" style={{ borderTopColor: 'var(--sea-bg)' }}><div className="sv" style={{ color: 'var(--ocean)' }}>{LECTURERS.length}</div><div className="sl">Total Lecturers</div><div className="ss">Active this term</div></div>
        <div className="sc" style={{ borderTopColor: 'var(--gold-bg)' }}><div className="sv" style={{ color: 'var(--ocean)' }}>3</div><div className="sl">STB Licensed</div><div className="ss">Tourist Guide Trainers</div></div>
        <div className="sc" style={{ borderTopColor: 'var(--violet)' }}><div className="sv" style={{ color: 'var(--ocean)' }}>2</div><div className="sl">AI Specialists</div><div className="ss">Dr. Priya Nair, Kevin Ng</div></div>
        <div className="sc" style={{ borderTopColor: 'var(--coral-bg)' }}><div className="sv" style={{ color: 'var(--red)' }}>1</div><div className="sl">Near Load Limit</div><div className="ss">Ms. Aishah: 18/20h</div></div>
      </div>
      <div className="g2">
        {LECTURERS.map((l) => (
          <div key={l.id} className="lec-card">
            <div className="lec-av" style={{ background: l.bg }}>{l.ini}</div>
            <div className="lec-in">
              <div className="lec-n">{l.name}</div>
              <div className="lec-t">{l.title}</div>
              <div className="lec-q">{l.quals.map((q) => <span key={q} className="qt">{q}</span>)}</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.35rem', marginBottom: '.6rem' }}>
                {l.types.map((t) => (
                  <span key={t} className={`pt ${PT[t].cls}`}><i className={`fa-solid ${PT[t].icon}`} style={{ fontSize: '.6rem' }} /> {PT[t].label}</span>
                ))}
              </div>
              <div className="lec-lw">
                <div className="lec-ll">Teaching Load:</div>
                <div style={{ flex: 1 }}><div className="pt-track"><div className={`pt-fill ${l.load >= l.max ? 'pf-coral' : l.load >= l.max * 0.85 ? 'pf-gold' : 'pf-sea'}`} style={{ width: `${(l.load / l.max * 100).toFixed(0)}%` }} /></div></div>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: '.75rem', fontWeight: 700, color: l.load >= l.max ? 'var(--red)' : l.load >= l.max * 0.85 ? 'var(--gold)' : 'var(--sea)' }}>{l.load}/{l.max}h</span>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '.42rem', flexShrink: 0 }}>
              <button className="btn btn-ghost btn-sm" onClick={() => show(`Viewing ${l.name} — coming soon`, 'info')}><i className="fa-solid fa-eye" /></button>
              <button className="btn btn-ghost btn-sm" onClick={() => show(`Editing ${l.name} — coming soon`, 'info')}><i className="fa-solid fa-pencil" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
